"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ssrWindow = require("ssr-window");
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ModalContent extends _react.Component {
  static defaultProps = {
    maxHeight: 'auto',
    verticalModalPadding: 32
  };
  constructor(props) {
    super(props);
    const {
      children,
      html
    } = props;
    if (children && html) {
      // eslint-disable-next-line no-console
      console.error('Passing children or html props is exclusive. You may only use one at a time.');
    }
  }
  componentDidMount() {
    _ssrWindow.window.addEventListener('resize', this._onWindowResize);
    this._resizeTimeout = _ssrWindow.window.setTimeout(() => {
      this._onWindowResize();
    }, 0);
  }
  componentWillUnmount() {
    _ssrWindow.window.clearTimeout(this._resizeTimeout);
    _ssrWindow.window.removeEventListener('resize', this._onWindowResize);
  }
  _onWindowResize = evt => {
    const {
      maxHeight,
      contentAreaHeight,
      verticalModalPadding
    } = this.props;
    const windowWidth = _ssrWindow.window.innerWidth || _ssrWindow.document.body.clientWidth;
    let calculatedMax = maxHeight;
    if ((0, _isString.default)(calculatedMax) && calculatedMax === 'auto') {
      const modalWrapperEl = _dom.default.parent(this._container, '.Modal-wrapper');
      const titleEl = modalWrapperEl.querySelector('.Modal-title');
      const finalContentAreaHeight = (0, _isUndefined.default)(contentAreaHeight) ? _dom.default.height(modalWrapperEl, true, false) - _dom.default.height(titleEl) : (0, _isFunction.default)(contentAreaHeight) ? contentAreaHeight() : contentAreaHeight;
      calculatedMax = windowWidth < 768 ? finalContentAreaHeight : finalContentAreaHeight - verticalModalPadding - 24; // 24 is margin-bottom
    }
    this._container.style.maxHeight = `${calculatedMax}px`;
  };
  render() {
    const {
      className,
      noPadding,
      contentAreaHeight,
      children,
      html
    } = this.props;
    const content = html ? /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: html
      }
    }) : children;
    const classes = (0, _classnames.default)('Modal-content', {
      'Modal-content-flush': noPadding
    }, {
      'Modal-content-with-height': !(0, _isUndefined.default)(contentAreaHeight)
    }, className);
    if (html && children) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: node => {
        this._container = node;
      },
      className: classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "Modal-content-wrapper"
    }, content));
  }
}
exports.default = ModalContent;